import axios from "@/plugins/axios";

let url = "/api/v1/me/carts";

export default {
    getCarts(data){
        return axios.get(url, data).then(result => result.data);
    },
    getCart(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postCart(data){
        return axios.post(url, data).then(result => result.data);
    },
    putCart(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteCart(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
